class FooterNewsletter extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['form', 'list', 'email', 'success']
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(
      this.els.form.element,
      'submit',
      this.onFormSubmit.bind(this),
    )
  }

  onFormSubmit (e) {
    e.preventDefault()

    const listId = this?.els?.list?.element?.value
    const email = this?.els?.email?.element?.value

    if (!this.validEmail(email)) return

    const data = {
      g: listId,
      email,
      $consent: ['email'],
    }
    const urlData = new URLSearchParams(data)

    fetch(`https://manage.kmail-lists.com/ajax/subscriptions/subscribe`, {
      method: 'POST',
      body: urlData,
    }).then(res => {
      if (res.status === 200) {
        this.els.form.element.setAttribute('aria-hidden', true)
        this.els.success.element.setAttribute('aria-hidden', false)
      }
    })
  }

  validEmail (email) {
    const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/
    return emailRegex.test(email)
  }
}

if (!customElements.get('footer-newsletter')) {
  customElements.define('footer-newsletter', FooterNewsletter)
}
